<template>
  <transition name="fade"
    ><ErrorComponent v-if="$store.getters['utils/error']"
  /></transition>
  <!-- <transition name="fade"
    ><Feedback v-if="$store.getters['utils/feedback']"
  /></transition> -->
  <router-view :key="$route.fullPath" />
</template>
